import { render } from "./ImagePanel.vue?vue&type=template&id=2db5f4a2&scoped=true"
import script from "./ImagePanel.vue?vue&type=script&lang=js"
export * from "./ImagePanel.vue?vue&type=script&lang=js"

import "./ImagePanel.vue?vue&type=style&index=0&id=2db5f4a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db5f4a2"]])

export default __exports__